module.exports = __webpack_public_path__ + "img/n9.4e3fafaf.png";